import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { Link } from "react_reusable_components";
import { TwoRow } from "../../core/layouts";
import AddProductCategoryFormContainer from "../../containers/AddProductCategoryFormContainer";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import variables from "../../themes/base/styles/variables";
import ViewProductCategoryContainer from "../../containers/ViewProductCategoryContainer";

export const AddProductCategoryStyle = {
  wrapperStyle: {
    backgroundColor: variables.grey5,
    padding: variables.paddingMedium,
    paddingTop: variables.paddingSmallLG,
  },
  bottomSectionStyle: {
    backgroundColor: variables.bodyBg,
    border: `1px solid ${variables.grey4}`,
    overflow: "hidden",
    height: `calc(100vh - 11.5rem)`,
  },
  topSectionStyle: {
    paddingBottom: `${variables.paddingMedium}`,
  },
  backArrow: {
    width: variables.iconWidthLarge,
    height: variables.iconHeightLarge,
    marginRight: variables.marginMediumSmall,
  },
};

export default function AddProductCategoryView() {
  const intl = useIntl();
  const navigate = useNavigate();
  const { id } = useParams();

  const [mode, setMode] = useState();
  const [labelText, setLabelText] = useState(
    "productCategory.addNewProductCategory"
  );

  useEffect(() => {
    if (!id) {
      setMode("add");
      setLabelText("productCategory.addNewProductCategory");
    } else {
      setMode(window.location.href.includes("view") ? "view" : "edit");
      setLabelText(
        window.location.href.includes("view")
          ? "productCategory.viewProductCategory"
          : "productCategory.editProductCategory"
      );
    }
  }, []);

  return (
    <TwoRow
      style={AddProductCategoryStyle.wrapperStyle}
      topSectionStyle={AddProductCategoryStyle.topSectionStyle}
      topSection={
        <Link
          onClick={(e) => {
            e.preventDefault();
            navigate("/product-category");
          }}
          type="backNavigation"
          iconSrc={"/icons/arrow_back.svg"}
          labelText={getLocalizedMessage(intl, labelText)}
        />
      }
      bottomSectionStyle={AddProductCategoryStyle.bottomSectionStyle}
      bottomSection={
        mode === "view" ? (
          <ViewProductCategoryContainer />
        ) : (
          <AddProductCategoryFormContainer isEditMode={mode === "edit"} />
        )
      }
    />
  );
}
